import { useDispatch, useSelector } from 'react-redux'
import { setAuthenticatedAction, setErrorAction } from './store/actions'
import { selectError } from './store/selectors'
import { selectAuthApiHost } from '../../globalSelectors'
import { history } from '../../store'
import { getLandingPageByDepartments } from '../../modules/navigation'
import { startTokenRefreshLoop } from '../../api/auth/token'

// ReSharper disable once InconsistentNaming
const Authentication = (props) => {
    /* Dispatch */
    const dispatch = useDispatch()
    const setAuthenticated = (status) => dispatch(setAuthenticatedAction(status))
    const setError = (err) => dispatch(setErrorAction(err))

    /* Selectors*/
    const error = useSelector(selectError)
    const host = useSelector(selectAuthApiHost)
    const authApiUrl = `${host}`

    const params = new URLSearchParams(window.location.search)
    const secureKey = params.get('secureKey')
    const authToken = sessionStorage.getItem('authToken')

    // Function to fetch a new token using the secure key
    const fetchToken = async (key) => {
        try {
            const response = await fetch(`${authApiUrl}/token`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ SecureKey: key })
            })

            if (response.ok) {
                const data = await response.json()
                sessionStorage.setItem('authToken', data.accessToken) 
                sessionStorage.setItem('refreshToken', data.refreshToken) 
                const tokenData = JSON.parse(data.accessToken) 
                setAuthenticated({
                    isAuthenticated: true,
                    departments: tokenData.Departments,
                    scopes: tokenData.Scopes,
                    userName: tokenData.UserName
                })
                startTokenRefreshLoop() // Keep the freshly-issued token refreshed
                // Redirect based on user's department
                const landingPage = getLandingPageByDepartments(tokenData.Departments)
                history.push(landingPage)
            } else {
                setError({
                    message: 'Error when logging in.',
                    error: `Error refreshing access token: ${response.statusText}`
                })
                setAuthenticated({
                    isAuthenticated: false,
                    departments: [],
                    scopes: [],
                    userName: ''
                })
                return null
            }
        } catch (err) {
            setError({
                message: 'Error when logging in.',
                error: err
            })
            setAuthenticated({
                isAuthenticated: false,
                departments: [],
                scopes: [],
                userName: ''
            })
        }
        return null
    }

    // Function to handle token expiration
    const handleTokenExpiration = (tokenData) => {
        const expirationDate = new Date(tokenData.Expires)
        const currentDate = new Date()
        const isExpiredOrAboutToExpire = expirationDate < new Date(currentDate.getTime() + 60000)

        if (isExpiredOrAboutToExpire) {
            // Token is expired or about to expire
            sessionStorage.removeItem('authToken')
            sessionStorage.removeItem('refreshToken')
            setError({
                message: 'Token is either expired or about to expire.',
                error: 'Cannot refresh the token.'
            })
            setAuthenticated({
                isAuthenticated: false,
                departments: [],
                scopes: [],
                userName: ''
            })
        } else {
            startTokenRefreshLoop() // Self-rescheduling refresh driven by token expiry
            setAuthenticated({
                isAuthenticated: true,
                departments: tokenData.Departments,
                scopes: tokenData.Scopes,
                userName: tokenData.UserName
            })
        }
    }

    if (!secureKey && !authToken) {
        window.location.replace(authApiUrl) // Redirect if no secure key or auth token
        return undefined
    } else if (!authToken && secureKey.length > 0) {
        fetchToken(secureKey) // Fetch token if secure key is present
    } else {
        const tokenData = JSON.parse(authToken)
        handleTokenExpiration(tokenData) // Handle token expiration
    }

    if (error) {
        return (
            <div id={props.id}>
                <p className={'error'}>{JSON.stringify(error)}</p>
            </div>
        )
    }

    return (
        <div id={props.id}>
            {props.children}
        </div>
    )
}
export default Authentication;
